import dayjs from 'dayjs'

export function formatMemberDate(value: Date) {
  return dayjs(value).format('YYYY年M月D日')
}

export const MEMBER_ACCOUNT_STATUS = {
  pendingApproval: { color: 'processing', text: '待审批' },
  active: { color: 'success', text: '账号正常' },
  rejected: { color: 'error', text: '已拒绝' },
  suspended: { color: 'warning', text: '账号已停用' }
} as const
